import { z } from 'zod';
import { UnionOfKeys } from '@anytag/shared-types';
import { SearchSchema } from '@anytag/shared-validations';

export const ProfilePostsFilterSchema = z.object({
  keyword: SearchSchema.types.string().optional(),
  endDate: SearchSchema.types.string().optional(),
  startDate: SearchSchema.types.string().optional(),
  brandAccountName: SearchSchema.types.string().optional()
});

export type ProfilePostsFilterFormValues = z.infer<typeof ProfilePostsFilterSchema>;
export type ProfilePostsFilterFormKeys = UnionOfKeys<ProfilePostsFilterFormValues>;
